import React, { useEffect, useState } from 'react';
import data from './Data'; //NewCommunityGrocery
import { NavLink, Route } from "react-router-dom";
import Ordergrocerymenubar from "./../Ordergrocery/Ordergrocerymenubar";
import Grocerymenu from "../Ordergrocerymenujson";
import UserInfo from "../googlebutton.component";
import { useDispatch, useSelector } from "react-redux";
import { useValidateUserAndGetDetailsQuery } from "../store/api/orderApi";
import { useGetProductsQuery } from "../store/api/productApi";
import Spinner from 'react-bootstrap/Spinner';



export const Product = ({ productItems, handleAddProduct, cartItems }) => {
    const productData = data.productItems;
    const userInfo = useSelector((state) => state.authentication.userInfo);
    const { data: userData } = useValidateUserAndGetDetailsQuery(userInfo.emailId);
    const { data: products, isLoading: loadingProducts } = useGetProductsQuery();


    useEffect(() => {
        setItems(products);
        let orderProductCategories = products?.map((curElem) => curElem.category);
        if(orderProductCategories?.includes("Others")){
            orderProductCategories = orderProductCategories.filter(category=>category!="Others");
            orderProductCategories = [...orderProductCategories, "Others"];
        }
        setCatItems(['All', ...new Set(orderProductCategories)]);
    }, [products])



    const [items, setItems] = useState(productData);
    const [catItems, setCatItems] = useState([]);
    const filterMenu = (categoryName) => {
        if (categoryName === "All") {
            console.log("All");
            setItems(products);
            return;
        }
        const updatedItems = products.filter((curElem) => {
            console.log(categoryName);

            return curElem.category == categoryName;
        });
        setItems(updatedItems);
    }
    return (
        loadingProducts ?
            <div className="spinner">
                <Spinner animation="border" />
            </div>
            :
            <div>

                <Ordergrocerymenubar filterMenu={filterMenu} catItems={catItems} />

                <div className="menu-items container-fluid ">
                    <div className="row">
                        <div className="col-12 mx-auto">
                            <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-2 g-lg-3 marginForProducts" >
                                {
                                    items?.map((productItem) => (
                                        <>
                                            <div class="col" key={productItem.id} style={{ maxWidth: "20rem" }}>
                                                <div class="p-3 border card-data text-center">
                                                    <figure>
                                                        <img src={productItem.image} alt={productItem.product} className="img-thumbnail" />
                                                    </figure>
                                                    <h1 className="product-details product-name" title={productItem.product}>{productItem.product}</h1>
                                                    <p className="product-details product-count" title={productItem.count}> {parseFloat(productItem.unitSize).toFixed(0)} {productItem.unitOfmeasurement} </p>
                                                    <p className="product-details product-points" title={productItem.points}>Points: {parseFloat(productItem.points).toFixed(0)}</p>
                                                    {
                                                        userData?.canSubmitNewOrder &&
                                                        <button type="button" disabled={cartItems.some(item=> item.id == productItem.id)} class="btn btn-primary cart-btn" title="Add to Cart"
                                                            onClick={() => handleAddProduct(productItem)}>
                                                            <i class="fas fa-shopping-cart"></i>
                                                            Add to Cart
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default Product;